import { reactive } from "vue";
import ErrorPopup from "../components/ErrorPopup.vue";

// 전역 에러 상태 관리
export const errorState = reactive({
  show: false,
  message: "",
});

// 에러 핸들러 함수
export function showError(message) {
  errorState.message = message || "오류가 발생했습니다.";
  errorState.show = true;
}

export function hideError() {
  errorState.show = false;
}

// API 에러를 처리하는 함수
export async function handleApiError(error) {
  let message = "오류가 발생했습니다.";

  if (error.response) {
    // 서버에서 응답을 받았지만 에러 상태
    const status = error.response.status;

    try {
      // 응답을 JSON으로 파싱 시도
      let data;
      if (error.response.json && typeof error.response.json === "function") {
        data = await error.response.json();
      } else if (error.response.data) {
        data = error.response.data;
      } else {
        // 응답 텍스트를 직접 파싱 시도
        const text = await error.response.text();
        try {
          data = JSON.parse(text);
        } catch {
          data = { message: text || `HTTP ${status} 오류` };
        }
      }

      if (data && data.error && data.error.message) {
        // 백엔드 에러 응답: {"success":false,"error":{"code":"BOOKING_005","message":"이미 예약한 수업입니다"}}
        message = data.error.message;
      } else if (data && data.message) {
        message = data.message;
      } else if (data && data.error) {
        message = data.error;
      } else {
        switch (status) {
          case 400:
            message = "잘못된 요청입니다.";
            break;
          case 401:
            message = "인증이 필요합니다.";
            break;
          case 403:
            message = "접근 권한이 없습니다.";
            break;
          case 404:
            message = "요청한 리소스를 찾을 수 없습니다.";
            break;
          case 500:
            message = "서버 오류가 발생했습니다.";
            break;
          default:
            message = `오류가 발생했습니다. (${status})`;
        }
      }
    } catch (parseError) {
      // JSON 파싱 실패 시 기본 메시지 사용
      switch (status) {
        case 400:
          message = "잘못된 요청입니다.";
          break;
        case 401:
          message = "인증이 필요합니다.";
          break;
        case 403:
          message = "접근 권한이 없습니다.";
          break;
        case 404:
          message = "요청한 리소스를 찾을 수 없습니다.";
          break;
        case 500:
          message = "서버 오류가 발생했습니다.";
          break;
        default:
          message = `오류가 발생했습니다. (${status})`;
      }
    }
  } else if (error.request) {
    // 요청은 보냈지만 응답을 받지 못함
    message = "네트워크 오류가 발생했습니다.";
  } else {
    // 요청 설정 중 오류
    message = error.message || "알 수 없는 오류가 발생했습니다.";
  }

  showError(message);
}

// Vue 플러그인으로 등록
export default {
  install(app) {
    // 전역 속성으로 추가
    app.config.globalProperties.$showError = showError;
    app.config.globalProperties.$hideError = hideError;
    app.config.globalProperties.$handleApiError = handleApiError;

    // 전역 컴포넌트로 등록
    app.component("ErrorPopup", ErrorPopup);
  },
};
